import React, { useEffect, useMemo, useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from '@mui/material'

interface Props {
  reportId: string
  onClose: () => void
  onReset: (reportId: string) => void
}

const GlobalResetDialog: React.FC<Props & DialogProps> = ({
  reportId,
  onClose,
  onReset,
  ...dialogProps
}) => {
  const handleReset = () => {
    onReset(reportId)
    onClose()
  }
  return (
    <Dialog fullWidth maxWidth="sm" {...dialogProps} onClose={onClose}>
      <DialogTitle>Reset Custom Settings</DialogTitle>
      <DialogContent>
        <p>
          Are you sure you want to set all charts to default settings for this
          report?
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleReset}>Reset</Button>
      </DialogActions>
    </Dialog>
  )
}

export default GlobalResetDialog
